import Overlay from "../Overlay";
import ActionButton from '../ActionButton'
import ConfirmationModal from '../ConfirmationModal';
import { mapGetters } from "vuex";
export default {
  name: 'kycFailure',
  components: {
    Overlay,
    ActionButton,
    ConfirmationModal
  },
  data () {
    return {
      message: {
        value: 'Your KYC could not be completed due to an error. Please link your bank account in the meanwhile.',
        type: 'warning',
        fieldName: 'generic',
        actions: [
          {
            title: "Retry",
            method: () => this.retryKYC(),
            isPrimary: true
          },
          {
            title: "Link Bank account",
            method: () => this.continueToEmandate(),
            isPrimary: false
          },
        ]
      },
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  mounted () {
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "OKYC_REGISTERED",
      propertyName: "RESULT",
      propertyValue: "FAILURE"
    });
  },
  methods: {
    continueToEmandate () {
      this.$router.push({ name: 'eMandate' })
    },
    retryKYC () {
      this.$router.push({ name: 'KYC Step 1' })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/kycFailure/component.js